import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Input
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import SearchIcon from "@mui/icons-material/Search";
import SaveIcon from "@mui/icons-material/Save";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import {
	resetGateLoyaltyPointOperationsList,
	gateLoyaltyPointOperationsListReq
} from "../../redux/actions/gateLoyaltyPointOperationsListAction";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import {
	resetGetFeeManagementList,
	getFeeManagementList
} from "../../redux/actions/getFeeManagementListAction";

import {
	resetUpdateFeeManagementList,
	updateFeeManagementList
} from "../../redux/actions/updateFeeManagementListAction";

import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";

import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import { getFeeManagementOperationsList } from "../../redux/actions/getFeeManagementOperationListAction";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import Autocomplete from "@mui/lab/Autocomplete";
import { getCustomerIdAndNameList } from "../../redux/actions/getCustomerIdAndNameListAction";
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const FeeManagement = () => {

	// var res = {};
	// res = {
	//   status: "success",
	//   responseCode: "10001",
	//   feeMasterDetailsVOList: [
	//     {
	//       acrobatName: "",
	//       aitRates: "0.00",
	//       chargeType: "Bank_Transfer, Card_Transfer",
	//       currency: "",
	//       custOption: "Y",
	//       feeCharges: "0.00",
	//       feeID: "19",
	//       feeName: "Load flat feee ",
	//       feeOwner: "Owner",
	//       feeUnit: "FlatRate",
	//       frequency: "Per_Transaction",
	//       isDisplay: "Y",
	//       keyWord: "Load",
	//       paymentBy: "Receiver",
	//       role: "Customer, Merchant, Agent",
	//       vatRates: "0.00",
	//     },
	//     {
	//       acrobatName: "",
	//       aitRates: "0.00",
	//       chargeType: "Bank_Transfer, Card_Transfer, Transfer",
	//       currency: "",
	//       custOption: "Y",
	//       feeCharges: "0.00",
	//       feeID: "18",
	//       feeName: "Pay fee Flat",
	//       feeOwner: "Owner",
	//       feeUnit: "FlatRate",
	//       frequency: "Per_Transaction",
	//       isDisplay: "Y",
	//       keyWord: "Purchase",
	//       paymentBy: "Sender",
	//       role: "Customer, Merchant, Agent",
	//       vatRates: "0.00",
	//     },
	//   ],
	// };

	const [checkedState, setCheckedState] = useState("");

	const [isLoading, setIsLoading] = useState(false);
	const [updateFeeManagementListStatus, setupdateFeeManagementListStatus] =
		useState(false);
	const [notificationOpen, setNotificationOpen] = useState(false);
	const [currency, setCurrency] = useState("");
	const [operationName, setOperationName] = useState("");
	const [feeName, setFeeName] = useState("");
	const [feeUnit, setFeeUnit] = useState("");
	// const [data, setdata] = useState([]);
	const [checkedIndex, setcheckedIndex] = useState([]);
	const [customerId, setCustomerId] = useState("");

	const classes = useStyles();
	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	const updateFeeManagementListRes = useSelector(
		({ updateFeeManagementList }) => updateFeeManagementList
	);

	const [feeCharges, setFeeCharges] = useState("");

	const [updateFeeManagementListArray, setUpdateFeeManagementListArray] =
		useState("");

	const [getFeeManagementListStatus, setGetFeeManagementListStatus] =
		useState(false);
	const [feeManagementResArray, setFeeManagementResArray] = useState([]);

	const [
		getFeeManagementOperationListStatus,
		setGetFeeManagementOperationListStatus
	] = useState(false);
	const [
		getFeeManagementOperationListArray,
		setGetFeeManagementOperationListArray
	] = useState([]);

	const [searchResult, setsearchResult] = useState([]);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
		setTotal("");
		setDataObject("");
		setCustomerId("");
		dispatch(resetUpdateFeeManagementList());
		dispatch(resetGetFeeManagementList());
	};
	// const [num, setNum] = useState('')
	// const handleChangesss = (e) => {
	// 	const inputValue = e.target.value;


	// 	const pattern = /^[0-9.]*$/;


	// 	if (pattern.test(inputValue)) {
	// 	  setValue(inputValue);
	// 	}
	//   };

	// const handleChangeFeeDD = (e) => {
	// 	const regex = /^[0-9\b]+$./;
	// 	if (e.target.value === "" || regex.test(e.target.value)) {
	// 		setNum(e.target.value);
	// 	}
	// };
	// const handleInputChangessss = (event) => {


	// 	event.target.value = event.target.value.replace(/\D/g, '');

	// 	if (event.target.value.length > 4) {
	// 		event.target.value = event.target.value.slice(0, 4);
	// 	}
	// }


	const handleChange = ({ target: { name, value } }) => {
		if (name === "currency") {
			// setCurrency(value);
			setCurrency(value == "Select Currency" ? "" : value);
		}

		if (name === "operationName") {
			// setOperationName(value);
			setOperationName(value == "Select OperationType" ? "" : value);
		}

		if (name === "feeName") {
			// setFeeName(value);
			Util.verifyAlphabet(value) ? setFeeName(value) : setFeeName(feeName);
		}

		if (name == "feeUnit") {
			setFeeUnit(value == "Select Fee Unit" ? "" : value);
		}
		if (name == "customerId") {
			setCustomerId(value);
		}

		// if (name == "feeCharges") {
		//   setFeeCharges(value);
		// }
	};

	const gateLoyaltyPointOperationsListRes = useSelector(
		({ gateLoyaltyPointOperationsList }) => gateLoyaltyPointOperationsList
	);

	const getFeeManagementListRes = useSelector(
		({ getFeeManagementList }) => getFeeManagementList
	);


	useEffect(() => {
		setsearchResult(getFeeManagementListRes.data.feeMasterDetailsVOList);
	}, [])

	const getFeeManagementOperationsListRes = useSelector(
		({ getFeeManagementOperationsList }) => getFeeManagementOperationsList
	);

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const getCustomerIdAndNameListRes = useSelector(
		({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
	);

	useEffect(() => {
		// getLoyaltyPointOperationsList();
	}, []);

	const getLoyaltyPointOperationsList = () => {
		const getLoyaltyPointOperationsListIs = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			}
		};

		return dispatch(
			gateLoyaltyPointOperationsListReq(
				getLoyaltyPointOperationsListIs,
				authToken
			)
		);
	};

	const getFeeManagementOperationsListReq = () => {
		setGetFeeManagementOperationListStatus(true);
		const getFeeManagementOperationsListIs = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			}
		};

		return dispatch(
			getFeeManagementOperationsList(
				getFeeManagementOperationsListIs,
				regenerateTokenRes.data.AuthToken
			)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getFeeManagementOperationsListReq();
		}
	}, [regenerateTokenRes.data.AuthToken]);

	// const getFeeManagementOperationsListReqFunc = () => {
	//   if (getFeeManagementOperationListStatus) {
	//     if (getFeeManagementOperationsListRes.data.status == "success") {
	//       // setNotificationOpen(true);
	//       setGetFeeManagementOperationListArray(getFeeManagementOperationsListRes.data.currencyList);
	//     }
	//     if (getFeeManagementOperationsListRes.data.status == "failed") {
	//       // setNotificationOpen(true);
	//       setGetFeeManagementOperationListArray(getFeeManagementOperationsListRes.data);
	//     }
	//   }

	// };

	// useEffect(() => {
	//   getFeeManagementOperationsListReqFunc();
	// }, []);

	const getFeeManagementListRequest = () => {
		setIsLoading(true);
		setGetFeeManagementListStatus(true);
		const getFeeManagementListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				feeName: feeName,
				feeUnit: feeUnit,
				operationName: operationName,
				currency: currency,
				customerId: customerId.split("-")[0] || ""
			}
		};

		return dispatch(getFeeManagementList(getFeeManagementListReq, authToken));
	};

	let obj = feeManagementResArray;
	console.log(obj, "objsss")

	// const getCurrIdx = (idx, value, isDisplay) => {
	// 	if (isDisplay == "isDisplay") {
	// 		obj[idx].isDisplay = value;
	// 		setFeeManagementResArray([]);
	// 		setFeeManagementResArray([].concat(obj));
	// 	} else {
	// 		obj[idx].custOption = value;
	// 		setFeeManagementResArray([]);
	// 		setFeeManagementResArray([].concat(obj));
	// 	}
	// };

	const getCurrIdx = (idx, value, type) => {
		const newData = [...feeManagementResArray];

		if (type === "isDisplay") {
			newData[idx].isDisplay = value;
		} else if (type === "custOption") {
			newData[idx].custOption = value;
		}

		setFeeManagementResArray(newData);

		if (!checkedIndex.includes(idx)) {
			setcheckedIndex(prev => [...prev, idx]);
		}
	};
	const [num, setNum] = useState('')
	const [getNum, setGetNum] = useState('');

	// const setValueFromInput = (e) => {
	// 	const reg = new RegExp("^[0-9.]{4}$");
	// 	console.log(reg.test(e.target.value));
	// 	if (reg.test(e.target.value) || e.target.value.length <= 4) {
	// 		setGetNum(e.target.value);
	// 	}
	// };

	// const handlefeeChargesFn = (idx, valuefeeCharges, namefeeCharges) => {
	// 	if (namefeeCharges == "feeCharges") {
	// 		// obj[idx].feeCharges = valuefeeCharges;
	// 		// setFeeManagementResArray([]);
	// 		// setFeeManagementResArray([].concat(obj));

	// 		const newData = [].concat(data);


	// 		// const reg = new RegExp("^[0-9.]{4}$");
	// 		// ^\d{0,4}$
	// 		// // console.log(reg.test(e.target.value));
	// 		// if (reg.test(e.target.value) || e.target.value.length <= 4) {
	// 		// 	setNum(e.target.value);
	// 		// }
	// 		const reg = new RegExp("^[0-9.]{0,7}$");
	// 		newData[idx].feeCharges = reg.test(valuefeeCharges) === true ? valuefeeCharges : newData[idx].feeCharges;
	// 		// console.log("valuesssFeeeCha", valuefeeCharges)

	// 		setdata(newData);
	// 		if (!checkedIndex.includes(idx)) {
	// 			setcheckedIndex([...checkedIndex, idx]);
	// 		}
	// 	}
	// 	if (namefeeCharges == "vatRates") {
	// 		// obj[idx].vatRates = valuefeeCharges;
	// 		// setFeeManagementResArray([]);
	// 		// setFeeManagementResArray([].concat(obj));
	// 		// const newData = [...data];
	// 		const newData = [].concat(data);
	// 		newData[idx].vatRates = valuefeeCharges;
	// 		setdata(newData);
	// 		// console.log("neewww dataaaa", newData)
	// 		if (!checkedIndex.includes(idx)) {
	// 			setcheckedIndex([...checkedIndex, idx]);
	// 		}
	// 	}
	// 	if (namefeeCharges == "aitRates") {
	// 		// obj[idx].aitRates = valuefeeCharges;
	// 		// setFeeManagementResArray([]);
	// 		// setFeeManagementResArray([].concat(obj));
	// 		// const newData = [...data];
	// 		const newData = [].concat(data);

	// 		newData[idx].aitRates = valuefeeCharges;
	// 		setdata(newData);
	// 		if (!checkedIndex.includes(idx)) {
	// 			setcheckedIndex([...checkedIndex, idx]);
	// 		}
	// 	}
	// 	if (namefeeCharges == "acrobatName") {
	// 		// obj[idx].acrobatName = valuefeeCharges == "" ? "Y" : "" || valuefeeCharges == "Y" ? "N" : "Y";
	// 		// setFeeManagementResArray([]);
	// 		// setFeeManagementResArray([].concat(obj));
	// 		// console.log("DAttssss",[].concat(data))
	// 		const newData = [].concat(data);
	// 		newData[idx].acrobatName = valuefeeCharges ? 'Y' : 'N';
	// 		setdata(newData);
	// 		if (!checkedIndex.includes(idx)) {
	// 			setcheckedIndex([...checkedIndex, idx]);
	// 		}
	// 	}

	// };

	const handlefeeChargesFn = (idx, value, name) => {
		const newData = [...feeManagementResArray];

		if (name === "feeCharges") {
			const reg = new RegExp("^[0-9.]{0,7}$");
			if (reg.test(value)) {
				newData[idx].feeCharges = value;
			}
		}

		if (name === "vatRates") {
			newData[idx].vatRates = value;
		}

		if (name === "aitRates") {
			newData[idx].aitRates = value;
		}

		if (name === "acrobatName") {
			newData[idx].acrobatName = value ? "Y" : "N";
		}

		setFeeManagementResArray(newData);

		if (!checkedIndex.includes(idx)) {
			setcheckedIndex(prev => [...prev, idx]);
		}
	};

	// const updateFeeManagementLists = () => {
	// 	setupdateFeeManagementListStatus(true);
	// 	const changedData = checkedIndex.map(i => data[i]);
	// 	console.log("CHANGEDATA", changedData)

	// 	// let arr1 = searchResult;
	// 	// let arr2 = feeManagementResArray;
	// 	// const modifiedEntries = (arrayOne, arrayTwo) => {
	// 	// 	let result = [];
	// 	// 	for (let i = 0; i < arrayTwo.length; i++) {
	// 	// 		if (arrayOne[i] && JSON.stringify(arrayOne[i]) !== JSON.stringify(arrayTwo[i])) {
	// 	// 			result.push(arrayTwo[i]);
	// 	// 		}
	// 	// 	}
	// 	// 	return result;
	// 	// }
	// 	const updateFeeManagementListReq = {
	// 		loginDetails: {
	// 			walletOwnerId: regenerateTokenRes.data.partnerId || ""
	// 		},
	// 		actionCustomerMasterRequestVO: {
	// 			currency: currency
	// 		},
	// 		feeMasterDetailsVOList: changedData
	// 	};
	// 	return dispatch(updateFeeManagementList(updateFeeManagementListReq, authToken));
	// };
	const updateFeeManagementLists = () => {
		setupdateFeeManagementListStatus(true);

		const changedData = checkedIndex.map(i => feeManagementResArray[i]);

		console.log("CHANGEDATA", changedData);

		const updateFeeManagementListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				currency: currency
			},
			feeMasterDetailsVOList: changedData
		};

		return dispatch(updateFeeManagementList(updateFeeManagementListReq, authToken));
	};


	const updateFeeManagementListResFunc = () => {
		if (updateFeeManagementListRes.data.status == "success") {
			setNotificationOpen(true);
			setUpdateFeeManagementListArray(updateFeeManagementListRes.data);
			getFeeManagementListRequest();
			setsearchResult(getFeeManagementListRes.data.feeMasterDetailsVOList)
			setcheckedIndex([]);
		}
		if (updateFeeManagementListRes.data.status == "failed") {
			setNotificationOpen(true);
			setUpdateFeeManagementListArray(updateFeeManagementListRes.data);
			if (
				updateFeeManagementListRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				updateFeeManagementListRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}

		if (updateFeeManagementListRes.data.status == "Failed") {
			setNotificationOpen(true);
			setUpdateFeeManagementListArray(updateFeeManagementListRes.data);
			if (
				updateFeeManagementListRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				updateFeeManagementListRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}
	};

	useEffect(() => {
		if (updateFeeManagementListStatus) {
			updateFeeManagementListResFunc();
		}
	}, [updateFeeManagementListRes.data.status]);

	useEffect(() => {
		if (getFeeManagementListRes.data.status) {
			getFeeManagementListResFun();
		}
	}, getFeeManagementListRes.data.status);

	const getFeeManagementListResFun = () => {
		if (getFeeManagementListStatus) {
			if (getFeeManagementListRes.data.status == "Failed") {
				setIsLoading(false);
				setFeeManagementResArray(getFeeManagementListRes.data);
				setGetFeeManagementListStatus(false);
				NotificationPopups(
					"error",
					"Failed",
					getFeeManagementListRes.data.description
				);
				if (
					getFeeManagementListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getFeeManagementListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getFeeManagementListRes.data.status == "failed") {
				setIsLoading(false);
				setFeeManagementResArray(getFeeManagementListRes.data);
				setGetFeeManagementListStatus(false);
				NotificationPopups(
					"error",
					"Failed",
					getFeeManagementListRes.data.description
				);
				if (
					getFeeManagementListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getFeeManagementListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getFeeManagementListRes.data.status == "success") {
				setIsLoading(false);
				setFeeManagementResArray(
					[].concat(getFeeManagementListRes.data.feeMasterDetailsVOList)
				);
				// setdata(getFeeManagementListRes.data.feeMasterDetailsVOList);
				setCheckedState(
					new Array(
						[].concat(
							getFeeManagementListRes.data.feeMasterDetailsVOList
						).length
					).fill(false)
				);
			}
			if (getFeeManagementListRes.data.status == "Not Found") {
				setIsLoading(false);
				setGetFeeManagementListStatus(false);
				NotificationPopups(
					"error",
					"Failed",
					getFeeManagementListRes.data.description
				);
			}
		}
	};

	const [total, setTotal] = useState("");
	const [total1, setTotal1] = useState("");
	var totalCheckboxArray = [];
	var totalCheckboxArray1 = [];
	const [dataObject, setDataObject] = useState("");

	var updatedCheckedState = "";

	const handleOnChange = (position) => {
		const updatedCheckedState = checkedState.map((item, index) =>
			index === position ? !item : item
		);

		setCheckedState(updatedCheckedState);

		const totalPrice = updatedCheckedState.reduce(
			(sum, currentState, index) => {
				if (currentState === true) {
					var objAddCheck = feeManagementResArray[index];
					var dataAddCheck = Object.assign(objAddCheck, { check: "Y" });
					return totalCheckboxArray.push(dataAddCheck);

					//   return totalCheckboxArray.push(
					//     (feeManagementResArray[index])
					//   );
				}
				if (currentState === false) {
					return totalCheckboxArray.splice(index);
				}
			},
			totalCheckboxArray
		);
		setTotal(totalCheckboxArray);
	};

	const filterOptionsL = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}
		const filterOptionsList = options.filter(
			(option) => option.includes(inputValue) || ""
		);
		return filterOptionsList.slice(0, 20);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getCustomerIdAndNameReq = {
				loginDetails: {
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				},
				actionCustomerMasterRequestVO: {
					customerNameOrId: ""
				}
			};
			dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
		}
	}, [regenerateTokenRes.data.status]);

	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid xs={12} item sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								id="name"
								label="Fee Name"
								type="text"
								fullWidth
								variant="standard"
								value={feeName}
								name="feeName"
								onChange={handleChange}
								style={{ marginTop: "-2px" }}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>
						</Grid>


						{/* NEW: Customer ID field */}
						<Grid xs={12} item sm={12} md={3} lg={3}>
							<Autocomplete
								id="combo-box-customer-id"
								options={[].concat(
									getCustomerIdAndNameListRes.data.currencyList || [""]
								)}
								getOptionLabel={(option) => option}
								filterOptions={filterOptionsL}
								value={customerId}
								onChange={(event, value) => setCustomerId(value || "")}
								renderInput={(params) => (
									<TextField
										autoFocus
										margin="dense"
										id="name"
										label="Merchant ID"
										style={{ marginTop: "3px" }}
										type="text"
										fullWidth
										{...params}
										name="customerId"
										variant="standard"
										sx={{
											"& .MuiInput-underline:before": {
												borderBottomColor: "gray",
											},
											"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
												borderBottomColor: "gray",
											},
											"& .MuiInput-underline:after": {
												borderBottomColor: "gray",
											},
										}}
									/>
								)}
							/>
						</Grid>


						<Grid xs={12} item sm={12} md={3} lg={3}>
							<TextField
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Fee Unit"
								variant="standard"

								fullWidth={true}
								name="feeUnit"
								value={feeUnit || "Select Fee Unit"}
								onChange={handleChange}
							>
								<MenuItem value="Select Fee Unit">Select Fee Unit</MenuItem>
								<MenuItem value="FlatRate">FlatRate</MenuItem>
								<MenuItem value="Percentage">Percentage</MenuItem>
							</TextField>
						</Grid>

						<Grid xs={12} item sm={12} md={3} lg={3}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Operation Type"
								type="name"
								fullWidth
								variant="standard"
								name="operationName"
								// value={operationName || ""}
								defaultValue={"Select OperationType" || operationName}
								onChange={handleChange}
								style={{ marginTop: "0" }}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem
									value="Select OperationType"
									selected="Select OperationType"
								>
									Select OperationType
								</MenuItem>

								{getFeeManagementOperationsListRes.data.currencyList &&
									[]
										.concat(getFeeManagementOperationsListRes.data.currencyList)
										.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
							</TextField>
						</Grid>

						<Grid xs={12} item sm={12} md={3} lg={3}>
							<TextField
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Currency"
								variant="standard"

								fullWidth={true}
								name="currency"
								required
								// value={currency || ""}
								defaultValue={"Select Currency" || currency}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								{adminCurrencyList.success &&
									[]
										.concat(adminCurrencyList.data.currencyList)
										.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
							</TextField>
						</Grid>
					</Grid>

					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1.5rem",
							marginBottom: "15px"
						}}
					>
						<Grid item md={5}>
							{/* <Button
                style={{
                  marginLeft: "0.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                onClick={getFeeManagementListRequest}
              >
                Search
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getFeeManagementListRequest}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
						<Grid item md={7}></Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : feeManagementResArray.length == undefined ||
					!getFeeManagementListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Fee Master
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Fee Master
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Fee ID{" "}
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Customer ID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Fee Name{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Fee Unit
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Frequency
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Operation
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Operation Sub Type
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Pay By
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Applicable to Role As
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Received By
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Charges
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Display
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Customer Option
											</TableCell>
											<TableCell
												align="center"
												style={{
													fontWeight: "bold",
													color: "white",
													padding: "0px 25px"
												}}
											>
												VAT%
											</TableCell>
											<TableCell
												align="center"
												style={{
													fontWeight: "bold",
													color: "white",
													padding: "0px 30px"
												}}
											>
												AIT%
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												AIT Calculate
											</TableCell>

										</TableRow>
									</TableHead>

									<TableBody>
										{feeManagementResArray &&
											[].concat(feeManagementResArray).map((row, index) => (
												<TableRow key={index}>
													<TableCell align="center">{row.feeID}</TableCell>
													<TableCell align="center">
														{!row.customerId || row.customerId === "" ? "-" : row.customerId}
													</TableCell>
													<TableCell align="center">{row.feeName}</TableCell>
													<TableCell align="center">{row.feeUnit}</TableCell>
													<TableCell align="center">{row.frequency}</TableCell>
													<TableCell align="center">{row.keyWord}</TableCell>
													<TableCell align="center">{row.chargeType}</TableCell>
													<TableCell align="center">{row.paymentBy}</TableCell>
													<TableCell align="center">{row.role}</TableCell>
													<TableCell align="center">{row.feeOwner}</TableCell>

													<TableCell align="center">
														<Input
															// autoFocus
															className="removeArrows"
															id="name"
															type="text"
															// inputProps={{ maxLength: 4 }}
															// inputProps={{
															// 	inputMode: 'numeric',
															// 	// pattern: '/^[0-9.]*$/',
															// 	// maxLength: 5,
															// 	onChange: handleInputChangessss
															// }}
															// value={num}
															value={row.feeCharges}
															// onChange={(e) => handlefeeChargesFn(e)}
															onChange={({ target: { value } }) =>
																handlefeeChargesFn(index, value, "feeCharges")
															}
														/>
													</TableCell>
													<TableCell align="center">
														<TextField
															select
															size="small"
															variant="standard"
															value={row.isDisplay}
															onChange={(e) => getCurrIdx(index, e.target.value, "isDisplay")}
														>
															<MenuItem value="Y">Y</MenuItem>
															<MenuItem value="N">N</MenuItem>
														</TextField>
														{/* <TextField
															select
															size="small"
															color="primary"
															// autoFocus={true}
															variant="standard"
															type="text"
															value={row.isDisplay}
															name="idDefault"
															fullWidth={true}
															onChange={handleChange}
														>
															<MenuItem
																value={"Y"}
																onClick={() =>
																	getCurrIdx(index, "Y", "isDisplay")
																}
															>
																Y
															</MenuItem>
															<MenuItem
																value={"N"}
																onClick={() =>
																	getCurrIdx(index, "N", "isDisplay")
																}
															>
																N
															</MenuItem>
														</TextField> */}
													</TableCell>
													<TableCell align="center">
														<TextField
															select
															size="small"
															color="primary"
															// autoFocus={true}
															type="text"
															value={row.custOption}
															variant="standard"

															name="idDefault"
															fullWidth={true}
															onChange={handleChange}
														>
															<MenuItem
																value={"Y"}
																onClick={() =>
																	getCurrIdx(index, "Y", "custOption")
																}
															>
																Y
															</MenuItem>
															<MenuItem
																value={"N"}
																onClick={() =>
																	getCurrIdx(index, "N", "custOption")
																}
															>
																N
															</MenuItem>
														</TextField>
													</TableCell>
													<TableCell align="left">
														<TextField
															// className="removeArrows"
															// autoFocus
															id="name"
															type="number"
															variant="standard"

															value={row.vatRates}
															onChange={({ target: { value } }) => {
																const vatRates = parseFloat(value)
																if (vatRates >= 0 || value === '') {
																	handlefeeChargesFn(index, value, "vatRates")
																}
															}}

														/>
													</TableCell>

													<TableCell align="center">
														<TextField
															// className="removeArrows"
															// autoFocus
															id="name"
															type="number"
															value={row.aitRates}
															variant="standard"

															onChange={({ target: { value } }) => {
																const aitRates = parseFloat(value);
																if (aitRates >= 0 || value === '') {
																	handlefeeChargesFn(index, value, "aitRates")
																}
															}}
														/>
													</TableCell>
													<TableCell align="center">
														<input
															type="checkbox"
															id={`custom-checkbox-${index}`}
															checked={row.acrobatName == "Y" ? true : false}
															// checked={checkedState[index]}
															// value={index}
															// onChange={handleChange}
															onChange={e => handlefeeChargesFn(index, e.target.checked, "acrobatName")
															}
														// onChange={() => handleOnChange(index)}
														/>
													</TableCell>
													{/* <TableCell align="center">
														<Input
															variant="outlined"
															placeholder="TextField"
															InputProps={{}}
															onChange={(e) => setValueFromInput(e)}
															// fullWidth
															// label="TextField"
															value={getNum}
														/>
													</TableCell> */}


												</TableRow>
											))}
									</TableBody>
								</Table>
								<Grid container>
									<Grid item md={5} lg={5}></Grid>
									<Grid item md={2} lg={2}>
										{/* <Button
											variant="contained"
											style={{
												backgroundColor: "#00b9f5",
												color: "white",
												margin: "15px"
											}}
											size="medium"
											align="center"
											onClick={updateFeeManagementLists}
										>
											Save
										</Button> */}
										{/* <CustomButton
											style={{
												padding: "8px"
											}}
											onClick={updateFeeManagementLists}
											endIcon={<SaveIcon />}
										>
											Save <SaveIcon />
										</CustomButton> */}
									</Grid>
									<Grid item md={5} lg={5}></Grid>
								</Grid>
							</TableContainer>
							<CustomButton
								style={{
									padding: "8px",
									marginLeft: "50%"
								}}
								onClick={updateFeeManagementLists}
								endIcon={<SaveIcon />}
							>
								Save <SaveIcon />
							</CustomButton>
						</Grid>
					</Card>
				)}
			</Layout>

			{updateFeeManagementListArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateFeeManagementListArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateFeeManagementListArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateFeeManagementListArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateFeeManagementListArray.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateFeeManagementListArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default FeeManagement;
